'use client';

import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { getAgentAvailability } from '@/server-functions/csForm/agentAvailability';
import Script from 'next/script';
import clsx from 'clsx';

export default function ContactOptions(props: {
  options: string[];
  setOption: (option: string) => void;
}) {
  const t = useTranslations('CSForm');
  const { options, setOption } = props;

  const [phoneAvailable, setPhoneAvailable] = useState<boolean>(false);
  const [liveChatAvailable, setLiveChatAvailable] = useState(false);
  const [liveChatOpen, setLiveChatOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [liveChatResponseTime, setLiveChatResponseTime] = useState(0);

  const openLiveChat = () => setLiveChatOpen(true);

  useEffect(() => {
    setLoading(true);
    getAgentAvailability()
      .then((r) => {
        setLiveChatAvailable(r.chatAvailable as boolean);
        setPhoneAvailable(r.phoneAvailable as boolean);

        if ((r.chatAverageResponseTime as number) !== 0) {
          const chatAverageResponseTime = r.chatAverageResponseTime / 60;
          setLiveChatResponseTime(Math.ceil(chatAverageResponseTime));
        } else {
          setLiveChatResponseTime(0);
        }
      })
      .catch((err) => {
        console.error('Error checking live chat availability', err);
        setLiveChatAvailable(false);
        setPhoneAvailable(false);
      })
      .finally(() => setLoading(false));
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-40 items-center justify-center">
        <div className="mt-20 h-12 w-12 animate-spin rounded-full border-4 border-neutral-20 border-t-primary-100" />
      </div>
    );
  }

  function getAvailableOptions() {
    // if (!liveChatAvailable) {
    //   return options?.filter((o) => o !== 'chat');
    // }
    return options;
  }

  const isOptionAvailable = (option: string) => {
    if (option === 'phone') {
      return phoneAvailable;
    }
    if (option === 'chat') {
      return liveChatAvailable;
    }
    return true;
  };

  return (
    <div className="px-4 pt-6 sm:px-8">
      {liveChatOpen && (
        <Script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=a9c0a572-a9ca-42aa-98ce-e7a11ad4f5f8"
        />
      )}
      <div className="mx-auto my-8 flex w-full max-w-screen-2xl flex-wrap justify-center sm:my-14 lg:my-16">
        {getAvailableOptions()?.map((o: string) => {
          const available = isOptionAvailable(o);

          return (
            <div className="w-full p-2 md:w-1/3" key={o}>
              <div
                className={clsx('content-center rounded-xl border p-6', {
                  'cursor-pointer hover:border-primary-100': available,
                  'cursor-not-allowed opacity-50': !available,
                })}
                onClick={() => {
                  // if (o === 'chat') {
                  //   openLiveChat();
                  //   return;
                  // }
                  if (available) {
                    setOption(o);
                  }
                }}
              >
                <div>
                  <img src={`/images/${o}-icon.svg`} alt={o} />
                </div>
                <div className="flex flex-wrap items-end">
                  <div className="mr-1 text-xl font-bold">{t(`title_${o}`)}</div>
                  {available && t(`title_addition_${o}`, { time: liveChatResponseTime }) && (
                    <div className="">
                      <span className="text-sm font-medium text-gray-500">
                        ({t(`title_addition_${o}`, { time: liveChatResponseTime })})
                      </span>
                    </div>
                  )}
                </div>
                <p>{available ? t(`description_${o}`) : t('serviceUnavailable')}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
